import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import {
  Spinner,
  TextAppearance,
  TextColor,
  TextCustom,
} from '@vw-marketing/us-components';
import axios from 'axios';

import { AppConstants } from '../../utils/app-constants';
import { handlePlaylistData } from '../../utils/general';
import { StyledContainer } from './styles';
import { useFeatureAppContent } from '../../hooks/use-feature-app-content';
import { useOnScreen } from '../../hooks/use-on-screen';
import { Video } from '../../typing/main';
import { VideoGallery } from '../../components/video-gallery';
import YouTubeVideoPlayer from '../../components/youtube-video-player';

export const TemplateLanding = () => {
  const textStyle = { color: TextColor.primary };
  const {
    mode,
    videos,
    margin,
    hideThumbnails,
    showArrowsWithThumbnails = 'yes',
    idPlaylist,
    setPlaylist,
    maxPlaylistVideos,
  } = useFeatureAppContent();

  const [isloading, setIsLoading] = useState<boolean>(true);
  const [mngVideos, setMngVideos] = useState(videos);

  const [mainContainerIsVisible, elementRef] = useOnScreen();
  const isPlaylist = setPlaylist && setPlaylist == 'yes' ? true : false;
  let maxVideos = '50';

  useEffect(() => {
    const fetchPlaylistData = async () => {
      if (!isPlaylist || !idPlaylist || _.isEmpty(idPlaylist)) return;

      let videosLimit = maxVideos;

      if (
        maxPlaylistVideos &&
        !_.isEmpty(maxPlaylistVideos) &&
        _.parseInt(maxPlaylistVideos)
      ) {
        videosLimit = maxPlaylistVideos;
      }

      try {
        const url = AppConstants.YTApiGetPlaylist.replace(
          '{playlistid}',
          idPlaylist,
        ).replace('{maxvideos}', videosLimit);

        const response = await axios.get(url, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        });

        if (response.status === 200 && response.data) {
          setMngVideos(handlePlaylistData(response.data));
          setIsLoading(false);
        } else {
          console.log('ERROR:: Fetching List: ', response.status);
        }
      } catch (error) {
        console.error('ERROR:: Fetching playlist data failed: ', error);
      }
    };

    fetchPlaylistData();
  }, [isPlaylist, idPlaylist]);

  const renderSingleVideo = () => (
    <>
      {videos?.[0]?.title && (
        <TextCustom appearance={TextAppearance.headline400} style={textStyle}>
          {videos[0].title}
        </TextCustom>
      )}
      {videos?.[0]?.videoId && (
        <StyledContainer>
          <YouTubeVideoPlayer
            videoId={videos[0].videoId}
            videoMargin={videos[0].videoMargin}
            videoWidth={videos[0].videoWidth}
            videoMaxWidth={videos[0].videoMaxWidth}
          />
        </StyledContainer>
      )}
    </>
  );

  const renderGallery = (videosToDisplay: Video[]) => (
    <div ref={elementRef} style={{ width: '100%' }}>
      <VideoGallery
        videos={videosToDisplay}
        margin={margin}
        mainContainerIsVisible={mainContainerIsVisible}
        hideThumbnails={hideThumbnails === 'yes'}
        showArrowsWithThumbnails={showArrowsWithThumbnails === 'yes'}
      />
    </div>
  );

  const renderLoader = () => (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Spinner variant="large" />
    </div>
  );

  if (mode !== 'gallery') {
    return renderSingleVideo();
  }

  if (!isPlaylist) {
    return renderGallery(videos as Video[]);
  }

  return isloading ? renderLoader() : renderGallery(mngVideos as Video[]);
};
